/**
 *
 * Asynchronously loads the component for WaitingListPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TrainingWaitingListPage = lazyLoad(
  () => import('./index'),
  module => module.TrainingWaitingListPage,
);
